import moment from 'moment'
import 'moment/locale/es-mx';
import React, {useState, useEffect} from 'react'
import firebase from '../firebase/config'
import { Line } from '@reactchartjs/react-chart.js'
import {Link, useHistory, useLocation} from 'react-router-dom';
import utils from '../firebase/utils';
import AgendaConfig from './AgendaConfig';

function Home() {

  let history = useHistory()
  const dataLocation = useLocation()

  const [user, setUser] = useState({})
  const [ordersPrice, setOrdersPrice] = useState(0)
  const [nno, setNno] = useState(0)
  const [orders, setOrders] = useState([])
  const [ordersNew, setOrdersNew] = useState([])
  const [labelsList, setLabelsList] = useState([])

  const [ordersPriceData, setOrdersPriceData] = useState([])
  const [ordersData, setOrdersData] = useState([])

  const [servicesData, setServicesData] = useState([])
  const [productsData, setProductsData] = useState([])
  
  const [countryInfo, setCountryInfo] = useState({})

  let [step1, setStep1] = useState(true)
  let [step2, setStep2] = useState(false)
  let [step3, setStep3] = useState(false)
  let [step4, setStep4] = useState(false)

  const getOrders = async(id) =>{
    let orders = [];
    let tipos = [];
    let nno = [];
    let newOrdersList = [];
    await firebase.db.collection('Ordenes').where("aliadoId", "==", id)
    .get().then(val => {
      val.docs.forEach(item=>{
        orders.push(item.data().precio)
        tipos.push(item.data())
        moment(item.data().createdOn).format("ddd, D MMM YYYY") === moment().format("ddd, D MMM YYYY") && newOrdersList.push( item.data() )
      })
    })
    await firebase.db.collection('Ordenes').where("aliadoId", "==", id).where("status", "==", "Por confirmar")
    .get().then(val => {
      val.docs.forEach(item=>{
        nno.push(item.data())
      })
    })
    let tiposFiltered = filterYear(tipos)
    console.log(tiposFiltered)
    filterOrders(tiposFiltered)
    setOrders(orders)
    setOrdersNew(newOrdersList)
    setNno(nno.length)
    setOrdersPrice(orders.reduce(getSum, 0))

  }

  function filterYear(list){
    let todayYear = moment().format("YYYY")
    let tipos = list.filter((prv)=>( moment(prv.createdOn.toDate()).format("YYYY") === todayYear ))
    return tipos
  }
  
  const getPS = async(id) =>{
    let products = [];
    let services = [];
    await firebase.db.collection('Localidades').where("aliadoId", "==", id).where("lc", "==", "Localidad Principal")
    .get().then(val => {
      val.docs.forEach(item=>{
        firebase.db.collection('Localidades').doc(item.id).collection("Servicios").get().then((val2)=>{
          val2.docs.forEach(i=>{
            services.push(i.data())
          })
        })
      })
    })
    await firebase.db.collection('Productos').where("aliadoId", "==", id)
    .get().then(val => {
      val.docs.forEach(item=>{
        products.push(item.data())
      })
    })
    filterPS(products, services)

  }

  function getSum(total, num) {
    return total + num;
  }

  function filterOrders(tipos){
    let dates = ['Ene', 'Feb', 'Mar', 'Abril', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
    let datesList = []
    let monthsO = {
      0: [],
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
      6: [],
      7: [],
      8: [],
      9: [],
      10: [],
      11: [],
    }
    let totalList = []
    let totalListLength = []
    tipos.forEach(order => {
      switch (order.createdOn.toDate().getMonth()) {
        case 0:
          monthsO[0].push(order.precio)
          break;
        case 1:
          monthsO[1].push(order.precio)
          break;
        case 2:
          monthsO[2].push(order.precio)
          break;
        case 3:
          monthsO[3].push(order.precio)
          break;
        case 4:
          monthsO[4].push(order.precio)
          break;
        case 5:
          monthsO[5].push(order.precio)
          break;
        case 6:
          monthsO[6].push(order.precio)
          break;
        case 7:
          monthsO[7].push(order.precio)
          break;
        case 8:
          monthsO[8].push(order.precio)
          break;
        case 9:
          monthsO[9].push(order.precio)
          break;
        case 10:
          monthsO[10].push(order.precio)
          break;
        case 11:
          monthsO[11].push(order.precio)
          break;
        default:
          break;
      }
    })
    for(let i = 0; i <= moment().toDate().getMonth(); i++ ){
      totalList.push(monthsO[i].reduce(getSum, 0))
      totalListLength.push(monthsO[i].length)
      datesList.push(dates[i])
    }
    setLabelsList(datesList)
    setOrdersPriceData(totalList)
    setOrdersData(totalListLength)
  }

  function filterPS(productos, servicios){
    let monthsO = {
      0: [],
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
      6: [],
      7: [],
      8: [],
      9: [],
      10: [],
      11: [],
    }
    let monthsO2 = {
      0: [],
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
      6: [],
      7: [],
      8: [],
      9: [],
      10: [],
      11: [],
    }
    let servicesList = []
    let productsList = []
    productos.forEach(product => {
      switch (product.createdOn.toDate().getMonth()) {
        case 0:
          monthsO[0].push(product)
          break;
        case 1:
          monthsO[1].push(product)
          break;
        case 2:
          monthsO[2].push(product)
          break;
        case 3:
          monthsO[3].push(product)
          break;
        case 4:
          monthsO[4].push(product)
          break;
        case 5:
          monthsO[5].push(product)
          break;
        case 6:
          monthsO[6].push(product)
          break;
        case 7:
          monthsO[7].push(product)
          break;
        case 8:
          monthsO[8].push(product)
          break;
        case 9:
          monthsO[9].push(product)
          break;
        case 10:
          monthsO[10].push(product)
          break;
        case 11:
          monthsO[11].push(product)
          break;
        default:
          break;
      }
    })
    servicios.forEach(service => {
      switch (service.createdOn.toDate().getMonth()) {
        case 0:
          monthsO2[0].push(service)
          break;
        case 1:
          monthsO2[1].push(service)
          break;
        case 2:
          monthsO2[2].push(service)
          break;
        case 3:
          monthsO2[3].push(service)
          break;
        case 4:
          monthsO2[4].push(service)
          break;
        case 5:
          monthsO2[5].push(service)
          break;
        case 6:
          monthsO2[6].push(service)
          break;
        case 7:
          monthsO2[7].push(service)
          break;
        case 8:
          monthsO2[8].push(service)
          break;
        case 9:
          monthsO2[9].push(service)
          break;
        case 10:
          monthsO2[10].push(service)
          break;
        case 11:
          monthsO2[11].push(service)
          break;
        default:
          break;
      }
    })
    for(let i = 0; i <= moment().toDate().getMonth(); i++ ){
      productsList.push(monthsO[i].length)
      servicesList.push(monthsO2[i].length)
    }
    setProductsData(productsList)
    setServicesData(servicesList)
  }

  const data = {
    labels: labelsList,
    datasets: [
      {
        label: 'Ordenes',
        data: ordersData,
        fill: true,
        backgroundColor: 'rgb(95, 64, 160, 0.3)',
        borderColor: 'rgb(95, 64, 160)',
        borderWidth: 1,
        lineTension: 0.5,
        steppedLine: false
      },
    ],
  }
  const data3 = {
    labels: labelsList,
    datasets: [
      {
        label: 'Monto acumulado',
        data: ordersPriceData,
        fill: true,
        backgroundColor: 'rgb(95, 64, 160, 0.3)',
        borderColor: 'rgb(95, 64, 160)',
        borderWidth: 1,
        lineTension: 0.5,
        steppedLine: false
      },
    ],
  }
  
  const data2 = {
    labels: labelsList,
    datasets: [
      {
        label: 'Productos',
        data: productsData,
        fill: true,
        backgroundColor: 'rgb(255, 148, 64, 0.2)',
        borderColor: 'rgb(255, 148, 64)',
        yAxisID: 'productos',
        borderWidth: 1,
        lineTension: 0.5,
      },
      {
        label: 'Servicios',
        data: servicesData,
        fill: true,
        backgroundColor: 'rgb(95, 64, 160, 0.2)',
        borderColor: 'rgb(95, 64, 160)',
        yAxisID: 'servicios',
        borderWidth: 1,
        lineTension: 0.5,
      },
    ],
  }
  
  const options2 = {
    scales: {
      yAxes: [
        {
          type: 'linear',
          display: false,
          position: 'left',
          id: 'productos',
        },
        {
          type: 'linear',
          display: false,
          position: 'right',
          id: 'servicios',
          gridLines: {
            drawOnArea: false,
          },
        },
      ],
    },
  }
  
  const options = {
    scales: {
      xAxes: [
        {
          display: true,
        }
      ],
      yAxes: [
        {
          display: true,
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  }  

  const getCountryInfo = async(pais) => {
    let data = await firebase.db.collection("Ciudades").doc(pais).get()
    return data
  }
  
  const ModalStart = () => {
    return (
    <div className="cc-modal-wrapper fadeIn">
      <div className="help-modal">
        <div className="row no-gutters">
          <div className="col-lg-6">
            <div className="help-modal-wrapper">

              <div className="help-modal-logo">
                <img src="/images/logo.png" />
              </div>

              <div className="help-content-text">
                <div>
                  <p className="mb-0">Hola,</p>
                  <p className="bold color-primary mb-0">{user.nombre}</p>
                </div>
                
                <div>
                  <p className="mb-0">Te damos la bienvenida a</p>
                  <p className="bold color-primary mb-0">Priority Pet</p>
                </div>
               
                <div>
                  <p className="mb-0">Ahora te invitamos a que sigas 
                    estos pasos para la 
                    configuración básica de inicio</p>
                </div>
              </div>

              <div>
                <div className="btn btn-primary btn-block" onClick={()=>{ setStep1(false); setStep2(true); }}>Comencemos</div>
                <div className="btn btn-secondary btn-block" onClick={()=>{setStep1(false); updateWelcome() }}>Omitir</div>
              </div>
            
            </div>
          </div>
          <div className="col-lg-6">
            <div className="help-modal-wrapper-absolute">
              <img src="/images/patas_1.png" style={{
                position: "absolute",
                top: 0,
                right: 0,
                width: "45%",
              }}/>
              <img src="/images/Productos-web.png" style={{
                bottom: "10%",
                left: "15%",
                right: "15%",
                width: "75%",
                position: "absolute",
              }}/>
            </div>
          </div>
        </div>
      </div>
    </div>
    )
  }
  
  const ModalStep1 = () => {
    return (
    <div className="cc-modal-wrapper fadeIn">
      <div className="help-modal">
        <div className="py-4 px-2" 
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
        >

          <div className="help-modal-tile">
            <p className="mb-0">Ingresa en configuración</p>
          </div>

          <div className="help-modal-wrapper-content">
            
            <p className="help-modal-p">Edita tus datos personales o de empresa en <span className="bold color-primary">"Mi cuenta"</span></p>
            
            <div className="help-modal-wrapper-img-row">
              <div className="help-modal-wrapper-img mx-3">
                <img src="/images/Img-config.png" />
              </div>
              <div className="help-modal-wrapper-img mx-3">
                <img src="/images/Img-micuenta.png" />
              </div>
            </div>
            
            <p className="help-modal-p">Ingresa tus <span className="bold color-primary"> "Datos Bancarios"</span>. Esta cuenta es 
              la que usará el equipo de <span className="bold color-primary">Priority Pet</span> para hacer 
              los pagos por las ventas de tus productos y servicios</p>

            <div className="help-modal-wrapper-img-row">
              <div className="help-modal-wrapper-img mx-3">
                <img src="/images/Img-config.png" />
              </div>
              <div className="help-modal-wrapper-img mx-3">
                <img src="/images/Img-micuenta.png" />
              </div>
              <div className="help-modal-wrapper-img mx-3">
                <img src="/images/Img-datosbancarios.png" />
              </div>
            </div>

          </div>

          <div className="help-modal-btn-row">
            <div className="btn btn-outline-secondary col-lg-4 mr-4" onClick={()=>{ setStep2(false); updateWelcome() }}>Omitir</div>
            <div className="btn btn-primary col-lg-4 ml-4" onClick={()=>{ setStep2(false); setStep3(true); }}>Continuar</div>
          </div>

        </div>
      </div>
    </div>
    )
  }
  
  const ModalStep2 = () => {
    return (
    <div className="cc-modal-wrapper fadeIn">
      <div className="help-modal">
        <div className="py-4 px-2"
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
        >

          <div className="help-modal-tile">
            <p className="mb-0">Ingresa en localidades</p>
          </div>

          <div className="help-modal-wrapper-content">
            <p className="help-modal-p"><span className="bold color-primary">Localidades</span> es el espacio físico en el que está ubicado tu negocio, como: oficina, clínica, local, etc.</p>
            <div className="help-modal-wrapper-img-row">
              <div className="help-modal-wrapper-img mx-3">
                <img src="/images/Img-config.png" />
              </div>
              <div className="help-modal-wrapper-img mx-3">
                <img src="/images/img-localidades.png" />
              </div>
            </div>
            <p className="help-modal-p mb-3" >Por defecto, se asigna como <span className="bold color-primary">"Localidad Principal"</span>, a la dirección que ingresaste al momento del registro</p>
            <p className="help-modal-p mb-3" >Puedes ingresar cada una de las localidades adicionales que tengas (si aplica).</p>
            <p className="help-modal-p" >Importante considerar qué: <span className="bold color-primary">Cada servicio puede estar asociado a una o a varias localidades</span></p>
            
          </div>

          <div className="help-modal-btn-row">
            <div className="btn btn-outline-secondary col-lg-4 mr-4" onClick={()=>{ setStep3(false); updateWelcome()}}>Omitir</div>
            <div className="btn btn-primary col-lg-4 ml-4" onClick={()=>{ setStep3(false); setStep4(true); }}>Continuar</div>
          </div>

        </div>
      </div>
    </div>
    )
  }
  
  const ModalEnd = () => {
    return (
      <div className="cc-modal-wrapper fadeIn">
      <div className="help-modal">
        <div className="py-4 px-2"
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
        >

          <div className="help-modal-tile">
            <p className="mb-0">¡Todo listo!</p>
          </div>

          <div className="help-modal-wrapper-content">
            <p className="help-modal-p mb-3 text-center">Ya puedes ingresar tus <span className="bold color-primary">productos, servicios y contenido.</span></p>
            <p className="help-modal-p mb-3 text-center">Gracias por ser parte de la comunidad <span className="bold color-primary">Priority Pet</span></p>
            <div className="help-modal-wrapper-img-row">
              <div className="help-modal-wrapper-img mx-3">
                <img src="/images/logo.png" />
              </div>
            </div>
          </div>

          <div className="help-modal-btn-row">
            <div className="btn btn-secondary col-lg-4" onClick={()=>{ setStep4(false); updateWelcome()}}>Cerrar y comenzar</div>
          </div>

        </div>
      </div>
    </div>
    )
  }

  async function updateAgendas(aliadoId){

    try{
      await firebase.db.collection("Localidades").where("aliadoId", "==", aliadoId).where("lc", "==", "Localidad Principal").get().then((loc)=>{
        let lid = loc.docs[0].data().localidadId
        
        firebase.db.collection("Localidades").doc(lid).collection("Servicios").get().then((servs)=>{
          servs.docs.forEach((serv)=>{
            firebase.db.collection("Localidades").doc(lid).collection("Servicios").doc(serv.data().servicioId).collection("Agenda").orderBy("date", "asc").get().then((days)=>{
              
              let spreadedData = days.docs[days.docs.length - 1] ? {...days.docs[days.docs.length - 1].data()} : {}
              
              let object = {
                localidadId: lid,
                ...spreadedData
              }

              let fecha = object.fecha ? object.fecha : ""
              let dateFormatted
              
              let listaText = fecha.split(" ")

              if( isNaN(parseInt( listaText[1] )) ){
                let newFecha = `${listaText[0]} ${listaText[2]} ${listaText[1]} ${listaText[3]}`
                dateFormatted = moment(newFecha, "ddd, D MMM YYYY")
              }else{
                let newFecha = `${listaText[0]} ${listaText[1]} ${listaText[2]} ${listaText[3]}`
                dateFormatted = moment(newFecha, "ddd, D MMM YYYY")
              }
              // console.log(dateFormatted)
              if(dateFormatted.isBefore(moment())){
                console.log("Si se tiene que actualizar: " )
                console.log(object)
                const dates = AgendaConfig.getDates()
                createNewUpgradedAgenda(dates, object, dateFormatted)
                // console.log(dates)

              }else{
                // console.log("No se tiene que actualizar: " )
                // console.log(object)
              }

            })
          })
        })

      })
    }catch(e){
      console.log("Error: ", e)
    }


  }

  async function createNewUpgradedAgenda(fechas, objeto, date){
    
    for(let i = 0; i < fechas.length; i++){
      let fecha = fechas[i]
      await firebase.db.collection("Localidades").doc(objeto.localidadId).collection('Servicios').doc(objeto.servicioId).collection("Agenda").doc(fecha).set({
        bloqueado: false,
        agendaId: firebase.db.collection("Localidades").doc(objeto.localidadId).collection('Servicios').doc(objeto.servicioId).collection("Agenda").doc().id,
        servicioId: objeto.servicioId,
        fecha: fecha,
        date: date.toDate(),
        horasDia: objeto.horasDia, 
        capacidadDia: objeto.capacidadDia,
        createdOn: moment().toDate(),
      });
    }

  }

  useEffect(() => {

    firebase.getCurrentUser().then((val)=>{
      setUser(val)
      getOrders(val.aliadoId)
      getPS(val.aliadoId)
      updateAgendas(val.aliadoId)
      firebase.getCountryInfo(val.pais).then((val)=>{
        setCountryInfo(val.data())
      })
    });
	}, [])

  return (
    <div className="main-content-container container-fluid px-4">
          
          {
            user.bienvenida === false && step1 ? <ModalStart/>
            : step2 ? <ModalStep1/>
            : step3 ? <ModalStep2/>
            : step4  ? <ModalEnd/> 
            : <></>
          }
          
          { user.cuentaActiva === false && user.cuentaActiva !== undefined 
          // {/* { user.cuentaActiva === undefined  */}
            ? 
              <div>
                
                {/* <div className="modal-starter-register">
                  <p className="modal-starter-register-p">Tu cuenta esta inactiva</p>
                  <a href="/profile" className="modal-starter-register-btn">Activar</a>
                </div> */}

                <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                  <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                    <div className="row align-items-center">
                      <div className="col">
                        <p className="page-title">Centro de control</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-3 mb-0">
                    <div className="row align-items-center justify-content-space-around">
                    </div>
                  </div>
                </div>

                <div className="row no-gutters">
                  <div className="col-lg-6">
                    <div className="cardtoinfo-wrapper fadeInTop">
                      <div className="cardtoinfo-img-wrapper">
                        <img src="../images/icons/a2x.png" className="cardtoinfo-img"/>
                      </div>
                      <div className="cardtoinfo-info-wrapper">
                        <p className="cardtoinfo-info-p-title">Órdenes recibidas</p>
                        <p className="cardtoinfo-info-p-desc">adwdwawdwadwdawdawdwadwadwdddddddddddawdawdawdw</p>
                        <Link className="btn btn-outline-secondary" to="/orders">Ver más</Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="cardtoinfo-wrapper fadeInTop">
                      <div className="cardtoinfo-img-wrapper">
                        <img src="../images/icons/b2x.png" className="cardtoinfo-img"/>
                      </div>
                      <div className="cardtoinfo-info-wrapper">
                        <p className="cardtoinfo-info-p-title">Actividad</p>
                        <p className="cardtoinfo-info-p-desc">adwdwawdwadwdawdawdwadwadwdddddddddddawdawdawdw</p>
                        <Link className="btn btn-outline-secondary" to="/orders">Ver más</Link>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="row no-gutters">
                  <div className="col-lg-4">
                    <div className="cardtoinfo-wrapper fadeInTop">
                      <div className="cardtoinfo-img-wrapper">
                        <img src="../images/icons/c2x.png" className="cardtoinfo-img"/>
                      </div>
                      <div className="cardtoinfo-info-wrapper">
                        <p className="cardtoinfo-info-p-title">Qué hay hoy</p>
                        <p className="cardtoinfo-info-p-desc">adwdwawdwadwdawdawdwadwadwdddddddddddawdawdawdw</p>
                        <Link className="btn btn-outline-secondary" to="/agenda">Ver más</Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="cardtoinfo-wrapper fadeInTop">
                      <div className="cardtoinfo-img-wrapper">
                        <img src="../images/icons/d2x.png" className="cardtoinfo-img"/>
                      </div>
                      <div className="cardtoinfo-info-wrapper">
                        <p className="cardtoinfo-info-p-title">Nuevos clientes</p>
                        <p className="cardtoinfo-info-p-desc">adwdwawdwadwdawdawdwadwadwdddddddddddawdawdawdw</p>
                        <Link className="btn btn-outline-secondary" to="/clients">Ver más</Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="cardtoinfo-wrapper fadeInTop">
                      <div className="cardtoinfo-img-wrapper">
                        <img src="../images/icons/e2x.png" className="cardtoinfo-img"/>
                      </div>
                      <div className="cardtoinfo-info-wrapper">
                        <p className="cardtoinfo-info-p-title">Eventos pendientes</p>
                        <p className="cardtoinfo-info-p-desc">adwdwawdwadwdawdawdwadwadwdddddddddddawdawdawdw</p>
                        <Link className="btn btn-outline-secondary" to="/agenda">Ver más</Link>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
            : 
              <div>
            
                <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                  <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                    <div className="row align-items-center">
                      <div className="col">
                        <p className="page-title">Ejecución mes actual</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-3 mb-0">
                    <div className="row align-items-center justify-content-space-around">
                      <Link to="/resume" className="btn btn-secondary">Ver todos</Link>
                      <i className="material-icons color-white display-5">help_outline</i>
                    </div>
                  </div>
                </div>
                
                <div className="row">
                
                  <div className="col-lg col-md-6 col-sm-6 mb-4">
                    <div className="stats-small stats-small--1 card card-small">
                      <div className="card-body p-0 d-flex">
                        <div className="d-flex flex-column m-auto">
                          <div className="stats-small__data text-center">
                            <span className="stats-small__label text-uppercase">Monto acumulado por órdenes</span>
                            <h6 className="stats-small__value count my-3">{countryInfo.simbolo ?? " "}{ordersPrice}</h6>
                          </div>
                        </div>
                        <Line data={data3} options={options} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg col-md-4 col-sm-6 mb-4">
                    <div className="stats-small stats-small--1 card card-small">
                      <div className="card-body p-0 d-flex">
                        <div className="d-flex flex-column m-auto">
                          <div className="stats-small__data text-center">
                            <span className="stats-small__label text-uppercase">Órdenes</span>
                            <h6 className="stats-small__value count my-3">{orders.length}</h6>
                          </div>
                        </div>
                        <Line data={data} options={options} />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg col-md-4 col-sm-6 mb-4">
                    <div className="stats-small card card-small">
                      <div className="card-body p-0 d-flex">
                        <Line data={data2} options={options2} />
                      </div>
                    </div>
                  </div>
                  
                </div>

                <div className="row">
                  <div className="col-lg-8 col-md-12 col-sm-12 mb-4">
                    <div className="card card-small">
                      <div className="card-header border-bottom">
                        <h6 className="m-0">Clientes</h6>
                      </div>
                      <div className="card-body pt-0">
                        <Line data={data} options={options} />
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                    <div className="card card-small pending-events">
                      <div className="card-header border-bottom">
                        <div className="row py-2 bg-light">
                          <div className="col-12 col-sm-8">
                            <h6 className="m-0">Eventos pendientes</h6>
                          </div>
                          <div className="col-12 col-sm-4 d-flex mb-2 mb-sm-0">
                            <a href="/orders" className="sub-link ml-auto mr-auto ml-sm-auto mr-sm-0 mt-3 mt-sm-0">Ver todo &rarr;</a>
                          </div>
                        </div>
                      </div>
                      <div className="card-body p-0">
                        
                        {ordersNew.length > 0 && <div className="pending-events__item d-flex p-3">
                          <p onClick={()=>{ history.push({ pathname: "/orders" }) }} className="cursor-pointer pending-events__p mb-0"><span className="pending-events__counte">{ordersNew.length}</span>Nuevas órdenes</p>
                        </div>}
                        {nno > 0 && <div className="pending-events__item d-flex p-3">
                          <p onClick={()=>{ history.push({ pathname: "/orders",  state: { status: "Por confirmar" } }) }} className="cursor-pointer pending-events__p mb-0"><span className="pending-events__counte">{nno}</span>Órdenes por confirmar</p>
                        </div>}
                        <div className="pending-events__item d-flex p-3">
                          <p onClick={()=>{ history.push({ pathname: "/messages" }) } } className="cursor-pointer pending-events__p mb-0"><span className="pending-events__counte">0</span>Mensajes</p>
                        </div>
                      </div>
                    </div>
                  </div>
                
                </div>

              </div>
          }
          </div>
    )

    async function updateWelcome(){
      await firebase.db.collection("Aliados").doc(user.aliadoId).update({
        bienvenida: true
      })
      // console.log("Perfil updateado de maravisha")
  }

}

export default Home